if ( typeof StickyAddToCart !== 'function' ) {

	class StickyAddToCart extends HTMLElement {

		connectedCallback() {

			this.productPage = this.closest('product-page') || document.querySelector('product-page');
			this.productVariants = this.productPage ? this.productPage.querySelector('product-variants') : null;
			this.multipackPicker = this.productPage ? this.productPage.querySelector('multipack-picker') : document.querySelector('multipack-picker');

			this.image = this.querySelector('[data-js-sticky-atc-image]');
			this.priceCurrentEls = this.querySelectorAll('[data-js-sticky-atc-price-current]');
			this.priceCompareEls = this.querySelectorAll('[data-js-sticky-atc-price-compare]');
			this.saleBadge = this.querySelector('[data-js-sticky-atc-sale-badge]');
			this.availabilityEls = this.querySelectorAll('[data-js-sticky-atc-availability]');
			this.button = this.querySelector('[data-js-sticky-atc-button]');
			this.buttonText = this.querySelector('[data-js-sticky-atc-button-text]');

			const sourceForm = document.getElementById(this.dataset.sourceButtonId);
			this.sourceButton = sourceForm ? sourceForm.querySelector('[data-js-product-add-to-cart]') : null;

			if ( this.button ) {
				this.button.addEventListener('click', this._onAddToCart.bind(this));
			}

			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this._onVariantChange.bind(this));
			}

			if ( this.multipackPicker ) {
				this.multipackPicker.addEventListener('MULTIPACK_TIER_CHANGE', this._onMultipackChange.bind(this));
			}

			this._initNavFromExistingTabs();
			this._initVisibilityTrigger();
		}

		_initVisibilityTrigger() {

			this.header = document.getElementById('site-header');

			// Mobil: pruh je vidět od začátku (žádný trigger). Desktop: pruh se
			// objeví, až skutečné tlačítko "Přidat do košíku" v produktu
			// zmizí ze zorného pole — a zakryje menu.
			if ( !this.sourceButton || !( 'IntersectionObserver' in window ) ) {
				return;
			}

			this._isDesktop = () => window.matchMedia('(min-width: 768px)').matches;

			this._applyVisibility = (visible) => {
				this.classList.toggle('is-visible', visible);
				if ( this.header ) {
					this.header.classList.toggle('sticky-atc-hide-header', visible && this._isDesktop());
				}
			};

			// O kolik dřív (v px) se má pruh objevit, než tlačítko doopravdy
			// zmizí ze zorného pole úplně.
			const EARLY_TRIGGER_PX = 400;

			this._observer = new IntersectionObserver((entries) => {
				const entry = entries[0];
				// !isIntersecting je pravda i když tlačítko ještě NENÍ ve
				// viewportu (je pod ním, uživatel k němu ještě nedoscrolloval)
				// — pruh se má objevit jen když je tlačítko NAD zmenšenou
				// hranicí (viz rootMargin níž), ne pod ní. Hranice pro
				// boundingClientRect.top musí odpovídat rootMargin, jinak by
				// tenhle směrový test odmítl přesně ten moment, kdy má podle
				// rootMargin poprvé spustit.
				const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < EARLY_TRIGGER_PX;
				this._applyVisibility(scrolledPast);
			}, {
				threshold: 0,
				// Horní hranice viewportu se posune o EARLY_TRIGGER_PX dolů,
				// takže se tlačítko "vyhodnotí" jako minuté o něco dřív, než
				// skutečně zmizí úplně — pruh se tak objeví o chviličku dřív.
				rootMargin: '-' + EARLY_TRIGGER_PX + 'px 0px 0px 0px'
			});

			this._observer.observe(this.sourceButton);

			window.addEventListener('resize', () => {
				this._applyVisibility(this.classList.contains('is-visible'));
			});
		}

		_initNavFromExistingTabs() {

			const navContainer = this.querySelector('[data-js-sticky-atc-nav]');
			if ( !navContainer ) return;

			// Nehádáme cíle sami — okopírujeme odkazy z existující sekce
			// "EH Product Tabs Nav" (sections/eh-product-tabs-nav.liquid),
			// kterou si redakce ručně nastavuje per produkt se správnými
			// štítky a cíli. Pokud sekce na stránce není, navigace v pruhu
			// zůstane prázdná (a CSS :empty ji schová).
			const sourceLinks = document.querySelectorAll('.eh-text-tabs .eh-text-tab');

			sourceLinks.forEach((sourceLink) => {
				const href = sourceLink.getAttribute('href');
				if ( !href || href.charAt(0) !== '#' ) return;

				const clone = sourceLink.cloneNode(true);
				clone.classList.add('sticky-atc__nav-link');

				clone.addEventListener('click', (e) => {
					e.preventDefault();
					const target = this._resolveTarget(href);
					if ( !target ) return;
					target.style.scrollMarginTop = ( Math.ceil(this.getBoundingClientRect().height) + 12 ) + 'px';
					target.scrollIntoView({ behavior: 'smooth', block: 'start' });
					history.pushState(null, '', href);
				});

				navContainer.appendChild(clone);
			});

			this._addFallbackLinks(navContainer);
			// Až po fallbacích — "Hodnocení" fallback si nese vlastní
			// .eh-stars-slot, který se má taky doplnit hvězdičkami.
			this._syncRatingStars(navContainer);
		}

		_addFallbackLinks(navContainer) {

			// Ne všechny produkty mají nakonfigurovanou "EH Product Tabs Nav"
			// — ale recenze, popis a související produkty jsou strukturálně
			// rozpoznatelné napříč (skoro) všemi produkty, takže je nabízíme
			// jako doplněk, i když redakční navigace chybí. Odkaz se přidá,
			// jen když ho tam ještě není (podle štítku) a cíl reálně existuje.
			this._addFallbackLink(navContainer, 'Popis', () =>
				document.querySelector('[id*="custom_liquid_ndiPQc"]')
			);
			this._addFallbackLink(navContainer, 'Hodnocení', () =>
				document.querySelector('[id*="judge_me_reviews_review_widget"], #judgeme_product_reviews'),
				{ withStars: true }
			);
			this._addFallbackLink(navContainer, 'Související produkty', () =>
				// Pozor: na stránce může být i DRUHÝ <product-recommendations>
				// bez id (blok "complementary" přímo v main-product, "doplňky
				// ke koupi"), který se v DOM objevuje dřív. Selektory se proto
				// zkouší v pořadí (ne jako jeden kombinovaný seznam), ať se
				// vždy nejdřív najde ten se skutečnou sekcí "Související
				// produkty", ne ten dřívější cross-sell blok.
				document.querySelector('[id$="__product-recommendations"]')
				|| document.querySelector('#shopify-section-product-recommendations')
				|| document.querySelector('product-recommendations')
			);
		}

		_addFallbackLink(navContainer, label, findTarget, options) {

			const withStars = !!( options && options.withStars );

			const alreadyPresent = Array.from(navContainer.querySelectorAll('a')).some((a) =>
				a.textContent.trim().toLowerCase().startsWith(label.toLowerCase())
			);
			if ( alreadyPresent ) return;

			const target = findTarget();
			if ( !target ) return;

			if ( !target.id ) {
				target.id = 'sticky-atc-fallback-' + Math.random().toString(36).slice(2, 8);
			}

			const link = document.createElement('a');
			link.href = '#' + target.id;
			link.className = 'sticky-atc__nav-link' + ( withStars ? ' eh-text-tab--rating' : '' );
			link.innerHTML = '<span class="eh-tab-text">' + label + '</span>'
				+ ( withStars ? ' <span class="eh-stars-slot" data-eh-jdgm-stars></span>' : '' )
				+ ' <svg class="eh-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

			link.addEventListener('click', (e) => {
				e.preventDefault();
				target.style.scrollMarginTop = ( Math.ceil(this.getBoundingClientRect().height) + 12 ) + 'px';
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
				history.pushState(null, '', '#' + target.id);
			});

			navContainer.appendChild(link);
		}

		_resolveTarget(href) {

			const id = href.replace(/^#/, '');
			const exact = document.getElementById(id);
			if ( exact ) return exact;

			// "target_id" v EH Product Tabs Nav je ruční, zkopírovaný text
			// (viz nápověda v sections/eh-product-tabs-nav.liquid), a
			// obsahuje i číslo konkrétní instance šablony
			// (shopify-section-template--<číslo>__<klíč-sekce>). To číslo
			// se ale může časem změnit (Shopify šablonu přegeneruje), takže
			// se přesné id snadno rozejde, i když sekce reálně existuje.
			// Klíč sekce za posledním "__" zůstává stabilní, takže když
			// přesná shoda selže, zkusíme najít cokoli, co jím končí.
			const parts = id.split('__');
			const key = parts[parts.length - 1];
			if ( !key || key === id ) return null;

			return document.querySelector('[id$="__' + key + '"]');
		}

		_syncRatingStars(navContainer) {

			const slot = navContainer.querySelector('[data-eh-jdgm-stars]');
			if ( !slot ) return;

			const findStars = () => {
				const badge = document.querySelector('.jdgm-preview-badge, .jdgm-prev-badge, [id*="__judge_me_reviews_preview_badge"]');
				return badge ? badge.querySelector('.jdgm-prev-badge__stars, .jdgm-star-rating, .jdgm-rev-widg__stars') : null;
			};

			const inject = () => {
				const stars = findStars();
				if ( !stars ) return false;
				slot.innerHTML = '';
				slot.appendChild(stars.cloneNode(true));
				return true;
			};

			if ( inject() ) return;

			let tries = 0;
			const timer = setInterval(() => {
				tries++;
				if ( inject() || tries > 200 ) clearInterval(timer);
			}, 100);
		}

		_computeStockText(variant, detailed) {
			const locales = KROWN.settings.locales;

			if ( !variant ) {
				return locales.products_availability_out_of_stock;
			}

			if ( detailed && variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 ) {
				const qty = variant.inventory_quantity;
				if ( qty > 10 ) return locales.products_availability_more_than_10;
				if ( qty >= 5 ) return locales.products_availability_more_than_5;
				if ( qty === 4 ) return locales.products_availability_4;
				if ( qty === 3 ) return locales.products_availability_3;
				if ( qty === 2 ) return locales.products_availability_last_2;
				if ( qty === 1 ) return locales.products_availability_last_1;
				return locales.products_availability_in_stock;
			}

			return variant.available ? locales.products_availability_in_stock : locales.products_availability_out_of_stock;
		}

		_onVariantChange(e) {

			const variant = e.target.currentVariant;
			const formatMoney = this.productVariants._formatMoney;

			this.priceCurrentEls.forEach((el) => {
				el.innerHTML = ( variant && formatMoney )
					? this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format)
					: '';
			});

			const onSale = !!( variant && variant.compare_at_price > variant.price );

			this.priceCompareEls.forEach((el) => {
				el.innerHTML = onSale ? this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format) : '';
				el.style.display = onSale ? '' : 'none';
			});

			if ( this.saleBadge ) {
				if ( onSale ) {
					const pct = Math.round(( ( variant.compare_at_price - variant.price ) / variant.compare_at_price ) * 100);
					this.saleBadge.textContent = 'sleva -' + pct + ' %';
					this.saleBadge.style.display = '';
				} else {
					this.saleBadge.style.display = 'none';
				}
			}

			this.availabilityEls.forEach((el) => {
				const detailed = el.hasAttribute('data-js-sticky-atc-availability-detailed');
				const textEl = el.querySelector('[data-js-sticky-atc-availability-text]');
				if ( textEl ) {
					textEl.textContent = this._computeStockText(variant, detailed);
				}
				el.classList.toggle('sticky-atc__availability--out', !( variant && variant.available ));
			});

			if ( this.image && variant && variant.featured_image && variant.featured_image.src ) {
				const src = variant.featured_image.src;
				this.image.src = src + ( src.indexOf('?') > -1 ? '&' : '?' ) + 'width=130';
			}

			if ( this.button && this.buttonText ) {
				if ( variant && variant.available ) {
					this.button.classList.remove('disabled');
					this.buttonText.textContent = KROWN.settings.locales.products_add_to_cart_button;
				} else {
					this.button.classList.add('disabled');
					this.buttonText.textContent = variant
						? KROWN.settings.locales.products_sold_out_variant
						: KROWN.settings.locales.products_unavailable_variant;
				}
			}
		}

		_onMultipackChange(e) {

			const detail = e.detail || {};

			if ( detail.isBase ) {
				// Tier "1 ks" = stejná cena/sleva/dostupnost jako aktuálně
				// vybraná hlavní varianta — žádný speciální přepočet netřeba.
				if ( this.productVariants ) {
					this._onVariantChange({ target: this.productVariants });
				}
				return;
			}

			const formatMoney = this.productVariants && this.productVariants._formatMoney;

			this.priceCurrentEls.forEach((el) => {
				el.innerHTML = ( detail.totalPriceCents != null && formatMoney )
					? this.productVariants._formatMoney(detail.totalPriceCents, KROWN.settings.shop_money_format)
					: '';
			});

			// Bundle varianty nemají compare_at_price (viz multipack-picker.liquid)
			// — procentuální slevu u nich řeší jen štítek v pickeru samotném.
			this.priceCompareEls.forEach((el) => {
				el.innerHTML = '';
				el.style.display = 'none';
			});

			if ( this.saleBadge ) {
				this.saleBadge.style.display = 'none';
			}

			// Skladovost i tlačítko se řídí dostupností VYBRANÉHO bundle
			// tieru (skutečná varianta, co se přidá do košíku), ne hlavního
			// produktu — ten může být skladem, i když je zrovna vyprodaný
			// konkrétní balíček (a naopak).
			const bundleVariant = {
				available: !!detail.available,
				inventory_management: detail.inventoryManagement,
				inventory_quantity: detail.inventoryQuantity,
			};

			this.availabilityEls.forEach((el) => {
				const detailed = el.hasAttribute('data-js-sticky-atc-availability-detailed');
				const textEl = el.querySelector('[data-js-sticky-atc-availability-text]');
				if ( textEl ) {
					textEl.textContent = this._computeStockText(bundleVariant, detailed);
				}
				el.classList.toggle('sticky-atc__availability--out', !bundleVariant.available);
			});

			if ( this.button && this.buttonText ) {
				if ( bundleVariant.available ) {
					this.button.classList.remove('disabled');
					this.buttonText.textContent = KROWN.settings.locales.products_add_to_cart_button;
				} else {
					this.button.classList.add('disabled');
					this.buttonText.textContent = KROWN.settings.locales.products_sold_out_variant;
				}
			}
		}

		_onAddToCart(e) {
			e.preventDefault();
			if ( this.button.classList.contains('disabled') ) return;
			this._trackAnalyticsEvent('sticky_add_to_cart_click');
			if ( this.sourceButton ) {
				this.sourceButton.click();
			}
		}

		_trackAnalyticsEvent(name) {
			if ( typeof window.clarity === 'function' ) {
				window.clarity('event', name);
			}
			if ( typeof window.gtag === 'function' ) {
				window.gtag('event', name, {
					event_category: 'sticky_add_to_cart',
					transport_type: 'beacon',
				});
			}
		}

	}

	if ( typeof customElements.get('sticky-add-to-cart') == 'undefined' ) {
		customElements.define('sticky-add-to-cart', StickyAddToCart);
	}

}
